import React, { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

import SoftBox from "../../../components/SoftBox";
import Footer from "../../Footer";

import { setLayout, useSoftUIController } from "../../../context";

function DashboardLayout({ children }) {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  return (
    <SoftBox
      component="main"
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        px: { xs: 2, md: 4.25 },
        pb: 4,
        minWidth: 0,
        minHeight: "100dvh",
        position: "relative",
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1542px) minmax(0, 1fr)",
        alignContent: "start",
        "& > *": { gridColumn: 2, minWidth: 0 },
        "& > .MuiAppBar-root": { gridColumn: "1 / -1" },

        [breakpoints.up("xl")]: {
          marginLeft: miniSidenav ? pxToRem(80) : pxToRem(280),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
      {children}
      <Footer />
    </SoftBox>
  );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
